import { BigNumber } from 'bignumber.js';
import { forEach } from 'lodash';

export function changeURLArg(obj) {
  let queryObj = createQueryObj()
  queryObj = { ...queryObj, ...obj };
  // console.log('queryObj', queryObj);
  const newQuery = Object.keys(queryObj)
    .filter((key) => queryObj[key])
    .map((key) => `${key}=${queryObj[key]}`)
    .join('&');
  // console.log('newQuery', newQuery);
  if (newQuery) {
    history.replaceState('', '', `${location.origin}${location.pathname}?${newQuery}`);
  } else {
    history.replaceState('', '', `${location.origin}${location.pathname}`);
  }
}

export function createQueryObj() {
  const query = location.search.slice(1);
  let queryObj = {};
  if (query) {
    forEach(query.split('&'), item => {
      let tempArr = item.split('=');
      queryObj[tempArr[0]] = tempArr[1];
    });
  }
  return queryObj
}

export function getSystemTheme() {
  const isDarkTheme = window.matchMedia('(prefers-color-scheme: dark)'); // 是深色
  // console.log('isDarkTheme', isDarkTheme);
  if (isDarkTheme.matches) {
    // 是深色
    return 'dark';
  } else {
    // 不是深色
    return 'light';
  }
}

/** 设置显示模式 */
export function setMode(mode) {
  if (mode) {
    document.documentElement.setAttribute('theme', 'dark');
  } else {
    document.documentElement.removeAttribute('theme');
  }
}

export async function getIP() {
  // return fetch('https://ipapi.co/json/')
  //   .then((response) => response.json())
  //   .then((data) => data.ip)
  //   .catch((error) => console.error(error));
  try {
    const response = await fetch('https://ipapi.co/json/');
    const res = await response.json();
    console.log('getIP', res);
    return res.ip;
  } catch (error) {
    // console.error('Error fetching IP address:', error);
    return getIPByIPIfy();
  }
}

export async function getIPByIPIfy() {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const res = await response.json();
    console.log('getIPByIPIfy', res);
    return res.ip;
  } catch (error) {
    console.error('Error fetching IP address:', error);
  }
}

export function getLocalIPs() {
  // debugger
  const ips = [];
  const RTCPeerConnection =
    window.RTCPeerConnection ||
    window.mozRTCPeerConnection ||
    window.webkitRTCPeerConnection;
  if (!RTCPeerConnection) {
    console.error('WebRTC is not supported by this browser');
    return;
  }

  const rtc = new RTCPeerConnection({ iceServers: [] });
  rtc.createDataChannel('');
  rtc
    .createOffer()
    .then((offer) => rtc.setLocalDescription(offer))
    .catch((error) => console.error(error));
  console.log('rtc', rtc);

  rtc.onicecandidate = (ice) => {
    console.log('ice', ice);
    if (!ice || !ice.candidate || !ice.candidate.candidate) return;
    const candidate = ice.candidate.candidate;
    const regex = /([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})/;
    const match = candidate.match(regex);
    if (match && !ips.includes(match[1])) {
      ips.push(match[1]);
      console.log('ips', ips);
      // this.ips = ips;
      return ips;
    }
  };
}

/** 加法 */
export function add(a, b) {
  a = BigNumber(a);
  b = BigNumber(b);
  return toNonExponential(a.plus(b).toNumber()); //结果需要用toNumber转为普通数字
}

/** 减法 */
export function minus(a, b) {
  a = BigNumber(a);
  b = BigNumber(b);
  return toNonExponential(a.minus(b).toNumber());
}

/** 乘法 */
export function mut(a, b) {
  a = BigNumber(a);
  b = BigNumber(b);
  return toNonExponential(a.multipliedBy(b).toNumber());
}

/** 除法 */
export function dev(a, b) {
  // console.log('a', a);
  // console.log('b', b);
  a = BigNumber(a);
  b = BigNumber(b);
  return toNonExponential(a.dividedBy(b).toNumber());
}

/** 科学计数法转数字 */
export function toNonExponential(num) {
  // console.log('num', num);
  try {
    var m = num.toExponential().match(/\d(?:.(\d*))?e([+-]\d+)/);
    return num.toFixed(Math.max(0, (m[1] || '').length - m[2]));
  } catch (error) {
    console.log(error);
  }
}

/** 找出数组中的最大最小值的对象 */
export function findMinMaxAmounts(arr) {
  // 过滤出 currencyCoinMinAmt 和 currencyCoinMaxAmt 都存在的对象
  const filteredArr = arr.filter(
    (item) => item.currencyCoinMinAmt && item.currencyCoinMaxAmt
  );

  // 找到 currencyCoinMinAmt 最小的对象
  const minAmountObj = filteredArr.reduce(
    (min, curr) =>
      parseFloat(curr.currencyCoinMinAmt) < parseFloat(min.currencyCoinMinAmt)
        ? curr
        : min,
    filteredArr[0]
  );

  // 找到 currencyCoinMaxAmt 最大的对象
  const maxAmountObj = filteredArr.reduce(
    (max, curr) =>
      parseFloat(curr.currencyCoinMaxAmt) > parseFloat(max.currencyCoinMaxAmt)
        ? curr
        : max,
    filteredArr[0]
  );

  return [minAmountObj, maxAmountObj];
}

export function parseWithUnit(val) {
  try {
    if (val >= 1000000000000) {
      return Math.round(val / 1000000000) / 1000 + 'T';
    } else if (val < 1000000000000 && val >= 1000000000) {
      return (val / 1000000000).toFixed(1) + 'B';
    } else if (val < 1000000000 && val >= 1000000) {
      return (val / 1000000).toFixed(1) + 'M';
    } else if (val < 1000000 && val >= 100000) {
      return Math.round(val / 10) / 100 + 'K';
    } else if (val < 100000 && val >= 1) {
      // return val;
      return val.toLocaleString();
    } else {
      return 0;
    }
  } catch (err) {
    console.log(err, val);
  }
}

export function parseData(data) {
  try {
    return JSON.parse(data);
  } catch (e) {
    console.log(e);
  }
}

export function sortByFirstLetter(array, propertyName) {
  // 使用Array.sort()方法对数组进行排序
  array.sort(function (a, b) {
    // 将name属性的值转换为小写以确保不区分大小写
    const nameA = a[propertyName].toLowerCase();
    const nameB = b[propertyName].toLowerCase();
    // 比较首字母
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    // 如果首字母相同，则按原始顺序排序
    return 0;
  });
  return array;
}

/** 根据 name 读取 cookie */
export function getCookie(name) {
  const re = new RegExp('(?:^|; )' + name + '=([^;]*)');
  const m = document.cookie.match(re);
  return m ? decodeURIComponent(m[1]) : null;
}

/** 
 * 在JavaScript中，可以通过检测浏览器视口的高度和文档的高度来判断是否存在安全底部。当存在安全底部时，浏览器视口的高度会小于文档的高度。
 * 我们使用window.innerHeight获取浏览器视口的高度，使用document.body.scrollHeight和document.documentElement.scrollHeight获取文档的高度。
 * 通过 比较两者的大小，如果浏览器视口的高度小于文档的高度，则说明存在安全底部。
 */
export function hasSafeArea() {
  // 获取浏览器视口的高度
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

  // 获取文档的高度
  const documentHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);

  // 判断浏览器视口的高度是否小于文档的高度
  if (viewportHeight < documentHeight) {
    return true; // 存在安全底部
  } else {
    return false; // 不存在安全底部
  }
}

// // 使用示例
// if (hasSafeArea()) {
//   console.log("iOS has safe bottom area");
// } else {
//   console.log("iOS doesn't have safe bottom area");
// }

// 在CSS中，我们可以通过env(safe-area-inset-bottom)属性来判断是否有安全底部。该属性会返回一个长度值，如果存在安全底部，则该值大于0；否则，该值为0。

// 以下是一个使用CSS判断iOS是否有安全底部的示例代码：

// @supports (padding-bottom: env(safe-area-inset-bottom)) {
//   /* 存在安全底部 */
//   .safe-area {
//     padding-bottom: env(safe-area-inset-bottom);
//   }
// }

// /* 不存在安全底部 */
// .safe-area {
//   padding-bottom: 0;
// }